let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("a0ogJ")]).then(() => parcelRequire('8Ldri'));